import React from "react";
import Icon from "../icons/Icon";
import { useSelectMenu } from "../../hooks/useSelectMenu";

function Select({ label, value, options, onChange, placeholder = "" }) {
  const {
    ids,
    shellRef,
    triggerRef,
    optionRefs,
    open,
    setOpen,
    openAt,
    insideDialog,
    closeAndRestoreFocus,
    handleTriggerKeyDown,
    handleOptionKeyDown,
  } = useSelectMenu(options.length);

  const selectedIndex = options.findIndex((option) => option.value === value);
  const currentLabel = options[selectedIndex]?.label ?? placeholder;

  const pick = (option) => {
    closeAndRestoreFocus();
    if (option.value !== value) onChange(option.value);
  };

  return (
    <>
      {open && insideDialog && <div className="select-scrim" aria-hidden="true" />}

      <div className="select-shell" ref={shellRef}>
        <span className="sr-only" id={ids.labelId}>
          {label}
        </span>

        <button
          className={open ? "select-trigger is-open" : "select-trigger"}
          type="button"
          ref={triggerRef}
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-controls={ids.listId}
          aria-labelledby={`${ids.labelId} ${ids.valueId}`}
          onClick={() => (open ? setOpen(false) : openAt(selectedIndex))}
          onKeyDown={(event) => handleTriggerKeyDown(event, selectedIndex)}
        >
          <span className="select-value" id={ids.valueId}>
            {currentLabel}
          </span>
          <Icon className="select-caret" name="chevron-down" size={16} />
        </button>

        {open && (
          <ul className="select-menu" role="listbox" id={ids.listId} aria-labelledby={ids.labelId}>
            {options.map((option, index) => (
              <li
                key={option.value}
                className={option.value === value ? "select-option is-selected" : "select-option"}
                role="option"
                aria-selected={option.value === value}
                tabIndex={-1}
                ref={(node) => {
                  optionRefs.current[index] = node;
                }}
                onClick={() => pick(option)}
                onKeyDown={(event) =>
                  handleOptionKeyDown(event, index, (target) => pick(options[target]))
                }
              >
                {option.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}

export default Select;
